import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ValidationErrorModel } from '../../models/validation-error.model';
import { uniqBy } from 'lodash';

@Component({
  selector: 'dsd-ext-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  standalone: false
})
export class FormComponent {
  @Input()
  helpText: boolean;

  @Output()
  formSubmit = new EventEmitter();

  @Output()
  formErrors = new EventEmitter();

  errors: Array<ValidationErrorModel> = [];

  onSubmit() {
    this.formSubmit.emit();
    // setTimeout pour s'assurer que le DOM est à jour
    setTimeout(() => {
      this.updateErrors();
    });
  }

  updateErrors() {
    setTimeout(() => {
      this.errors = this.getVisibleErrors();
      if (this.errors.length > 0) {
        this.formErrors.emit(this.errors);
      }
    });
  }

  private getVisibleErrors(): Array<ValidationErrorModel> {
    const errors = [
      ...document.querySelectorAll('dsd-radio-group, dsd-checkbox-group, dsd-input, dsd-textarea, dsd-select')
    ]
      .filter(element => this.isElementInError(element))
      .map(element => this.toErrorValidation(element));

    return uniqBy(errors, 'text');
  }

  private isElementInError(element: Element): boolean {
    return element.hasAttribute('error') && element.getAttribute('error') !== 'false'; // error et error="true" sont possibles
  }

  private toErrorValidation(element: Element): ValidationErrorModel {
    let text = '';

    const parentFieldset = element.closest('fieldset');
    if (parentFieldset) {
      text = this.extractLegend(parentFieldset);
    } else {
      text = this.extractLabel(element) || this.extractLegend(element);
    }

    return {
      id: element.getAttribute('identifier') || element.querySelector('[id]').getAttribute('id'), // dans certains cas l'id est dans le component (dsd-radio-group)
      text: text.replace('* ', '')
    };
  }

  private extractLegend(element: Element): string {
    const legend = element.querySelector('[slot=legend]') as HTMLElement;
    return legend ? legend.innerText : null;
  }

  private extractLabel(element: Element): string {
    const label = element.querySelector('[slot=label]') as HTMLElement;
    return label ? label.innerText : null;
  }
}
